module.exports = __webpack_public_path__ + "img/wy.b3c89b77.png";